export enum UserType {
    Agent = 0,
    OfficeManager = 1,
    BranchAdmin = 2,
    SuperAdmin = 3,
    Delegate = 4,
    LOBUser = 5
}
export enum PhoneNoType {
    Fax = 1,
    Home = 2,
    Mobile = 3,
    Preferred = 98,
    Tollfree = 100,
}

export enum EntityState {
    None = "None",
    Added = "Added",
    Modified = "Modified",
    Deleted = "Deleted"
}

export enum DocusignState {
    Activated = "Activated",
    Expired = "Expired",
    PendingCharge = "PendingCharge",
    InQueue = "InQueue",
    Exception = "Exception",
    Closed = "Closed",
    PendingActivation = "PendingActivation",
    History = "History"
}